import { _ as _objectSpread2, a as _unsupportedIterableToArray } from './unsupportedIterableToArray-d4b21e24.esm.js';
import * as tokens$1 from '@hover/tokens-size';
import * as tokens from '@hover/tokens-space';
import _pick from 'ramda/src/pick';
import _map from 'ramda/src/map';
import * as tokens$2 from '@hover/tokens-typography';
import capsizesJson from '@hover/tokens-typography/assets/capsizes.json';
import { capitalize, fromEntries, entries, uncapitalize } from '@hover/utilities';
import '@hover/tokens-depth';
import * as tokens$3 from '@hover/tokens-size/next';

var color = ['primary', 'success', 'warning', 'danger', 'neutral', 'light'];
var fill = ['solid', 'outline', 'minimal'];
var shapeEqual = ['circle', 'square'];
var shape = /*#__PURE__*/['pill', 'box'].concat(shapeEqual);
var size$7 = ['small', 'medium', 'default', 'large'];
var variant$1 = ['primary', 'secondary', 'tertiary', 'ghost'];
// TODO(tokens-size): move button sizes into tokens and read from there

var baseSizes = {
  small: {
    paddingLeft: tokens.size400,
    paddingRight: tokens.size400,
    height: tokens$1.size200
  },
  medium: {
    paddingLeft: tokens.size500,
    paddingRight: tokens.size500,
    height: tokens$1.size300
  },
  large: {
    paddingLeft: tokens.size600,
    paddingRight: tokens.size600,
    height: tokens$1.size400
  }
};
var baseEqualSizes = {
  small: {
    height: tokens$1.size200,
    width: tokens$1.size200
  },
  medium: {
    height: tokens$1.size300,
    width: tokens$1.size300
  },
  large: {
    height: tokens$1.size400,
    width: tokens$1.size400
  }
};
var sizes$3 = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, baseSizes), {}, {
  "default": baseSizes.medium
});
var equalSizes = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, baseEqualSizes), {}, {
  "default": baseEqualSizes.medium
});

var size$6 = ['default', 'small', 'medium', 'large'];

var size$5 = ['small', 'medium', 'default', 'large'];

var size$4 = ['small', 'medium', 'large'];
var variant = ['solid', 'brand'];

var size$3 = [100, 200, 300, 400, 500, 600, 650, 700, 800, 900];
var presets$1 = {
  100: {
    color: tokens$2.heading100Color,
    fontFamily: tokens$2.heading100Family,
    fontSize: tokens$2.heading100Size,
    fontWeight: tokens$2.heading100Weight,
    lineHeight: tokens$2.heading100Height,
    marginBottom: tokens$2.heading100Margin
  },
  200: {
    color: tokens$2.heading200Color,
    fontFamily: tokens$2.heading200Family,
    fontSize: tokens$2.heading200Size,
    fontWeight: tokens$2.heading200Weight,
    lineHeight: tokens$2.heading200Height,
    marginBottom: tokens$2.heading200Margin
  },
  300: {
    fontWeight: tokens$2.heading300Weight,
    fontFamily: tokens$2.heading300Family,
    color: tokens$2.heading300Color,
    fontSize: tokens$2.heading300Size,
    lineHeight: tokens$2.heading300Height,
    marginBottom: tokens$2.heading300Margin
  },
  400: {
    fontWeight: tokens$2.heading400Weight,
    color: tokens$2.heading400Color,
    fontFamily: tokens$2.heading400Family,
    fontSize: tokens$2.heading400Size,
    lineHeight: tokens$2.heading400Height,
    marginBottom: tokens$2.heading400Margin
  },
  500: {
    fontWeight: tokens$2.heading500Weight,
    color: tokens$2.heading500Color,
    fontFamily: tokens$2.heading500Family,
    fontSize: tokens$2.heading500Size,
    lineHeight: tokens$2.heading500Height,
    marginBottom: tokens$2.heading500Margin
  },
  600: {
    fontWeight: tokens$2.heading600Weight,
    color: tokens$2.heading600Color,
    fontFamily: tokens$2.heading600Family,
    fontSize: tokens$2.heading600Size,
    lineHeight: tokens$2.heading600Height,
    marginBottom: tokens$2.heading600Margin
  },
  /**
   * @deprecated use 600
   */
  650: {
    fontWeight: tokens$2.heading650Weight,
    color: tokens$2.heading650Color,
    fontFamily: tokens$2.heading650Family,
    fontSize: tokens$2.heading650Size,
    lineHeight: tokens$2.heading650Height,
    marginBottom: tokens$2.heading650Margin
  },
  700: {
    fontWeight: tokens$2.heading700Weight,
    color: tokens$2.heading700Color,
    fontFamily: tokens$2.heading700Family,
    fontSize: tokens$2.heading700Size,
    lineHeight: tokens$2.heading700Height,
    marginBottom: tokens$2.heading700Margin
  },
  800: {
    fontWeight: tokens$2.heading800Weight,
    color: tokens$2.heading800Color,
    fontFamily: tokens$2.heading800Family,
    fontSize: tokens$2.heading800Size,
    lineHeight: tokens$2.heading800Height,
    marginBottom: tokens$2.heading800Margin
  },
  900: {
    fontWeight: tokens$2.heading900Weight,
    color: tokens$2.heading900Color,
    fontFamily: tokens$2.heading900Family,
    fontSize: tokens$2.heading900Size,
    lineHeight: tokens$2.heading900Height,
    marginBottom: tokens$2.heading900Margin
  }
};
var aliases$1 = {
  xs: 100,
  small: 200,
  medium: 400,
  large: 600,
  xl: 700,
  xxl: 900
};
var sizes$2 = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight']), presets$1);
var capsizes$1 = capsizesJson.heading;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

/**
 * Union of components with size presets available inferred from tokens
 */

/**
 * Given a component name and size, produce a union of available
 * properties defined in size tokens for said component and size
 */

/**
 * Given a component name, size and property name, retrieve
 * the type of the value of the specific token
 */

/**
 * Retrieve size token(s) for a component of a specific size. If said
 * component/size combination produces a single value, that value will be
 * returned. If the component/size combination includes several values, those
 * value will be returned in object form (usually ready to apply as CSS values).
 *
 * We get a little fancy here with template literal types in order to be able
 * to produce accurate return values based on the available size tokens.
 *
 * @example
 * ```ts
 * getSizePresetFromTokens('Icon', 'small');
 * // {
 * //   width: '100px',
 * //   height: '100px',
 * //   ...
 * // }
 * ```
 *
 * @param component
 * @param size
 */
var getSizePresetFromTokensFactory = function getSizePresetFromTokensFactory(tokens) {
  return function (component, size) {
    var capitalizedSize = capitalize(size);
    var prefix = "size".concat(component).concat(capitalizedSize);
    if (Object.keys(tokens).includes(prefix)) return tokens[prefix];
    return fromEntries(entries(tokens).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key.startsWith(prefix);
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      return [uncapitalize(key.replace(new RegExp("^".concat(prefix)), '')), value];
    }));
  };
};
var getSizePresetFromTokens = /*#__PURE__*/getSizePresetFromTokensFactory(tokens$1);
var getSizePresetFromNextTokens = /*#__PURE__*/getSizePresetFromTokensFactory(tokens$3);

var size$2 = ['tiny', 'small', 'medium', 'default', 'large', 'huge'];
// TODO(default-size): deprecate `default` size in all size maps and export
// member from `size` (e.g: `export defaultSize = 'small'`) tuple instead (to
// be passed as `defaultProp` in Chakra, for example)
var sizes$1 = /*#__PURE__*/fromEntries( /*#__PURE__*/size$2.map(function (s) {
  return [s, getSizePresetFromTokens('Icon', s === 'default' ? 'small' : s)];
}));

var size$1 = ['default', 'small', 'medium', 'large'];

var size = [200, 300, 400, 500, 600];
var presets = {
  200: {
    color: tokens$2.body200Color,
    fontFamily: tokens$2.body200Family,
    fontSize: tokens$2.body200Size,
    fontWeight: tokens$2.body200Weight,
    lineHeight: tokens$2.body200Height
  },
  300: {
    fontWeight: tokens$2.body300Weight,
    fontFamily: tokens$2.body300Family,
    color: tokens$2.body300Color,
    fontSize: tokens$2.body300Size,
    lineHeight: tokens$2.body300Height
  },
  400: {
    fontWeight: tokens$2.body400Weight,
    fontFamily: tokens$2.body400Family,
    color: tokens$2.body400Color,
    fontSize: tokens$2.body400Size,
    lineHeight: tokens$2.body400Height
  },
  500: {
    fontWeight: tokens$2.body500Weight,
    fontFamily: tokens$2.body500Family,
    color: tokens$2.body500Color,
    fontSize: tokens$2.body500Size,
    lineHeight: tokens$2.body500Height
  },
  600: {
    fontWeight: tokens$2.body600Weight,
    fontFamily: tokens$2.body600Family,
    color: tokens$2.body600Color,
    fontSize: tokens$2.body600Size,
    lineHeight: tokens$2.body600Height
  }
};
var aliases = {
  footnote: 200,
  small: 300,
  medium: 400
};
var sizes = /*#__PURE__*/_map( /*#__PURE__*/_pick(['fontSize', 'lineHeight']), presets);
var capsizes = capsizesJson.body;

export { _slicedToArray as _, shape as a, shapeEqual as b, color as c, size$7 as d, equalSizes as e, fill as f, getSizePresetFromNextTokens as g, sizes$3 as h, size$6 as i, size$3 as j, size$5 as k, sizes$1 as l, size$4 as m, size$1 as n, size as o, variant$1 as p, aliases$1 as q, sizes$2 as r, size$2 as s, presets$1 as t, capsizes$1 as u, variant as v, aliases as w, sizes as x, presets as y, capsizes as z };
